import { render, staticRenderFns } from "./tableArea.vue?vue&type=template&id=188acbc2&scoped=true"
import script from "./tableArea.vue?vue&type=script&lang=js"
export * from "./tableArea.vue?vue&type=script&lang=js"
import style0 from "./tableArea.vue?vue&type=style&index=0&id=188acbc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188acbc2",
  null
  
)

export default component.exports